export interface PresignedUploadOptions {
  uploadUrl: string;
  body: Blob;
  contentType: string;
  headers?: Record<string, string>;
}

export async function putPresignedObject(opts: PresignedUploadOptions): Promise<Response> {
  const headers = { ...(opts.headers ?? {}) };
  if (!headers['Content-Type']) {
    headers['Content-Type'] = opts.contentType;
  }

  try {
    return await fetch(opts.uploadUrl, {
      method: 'PUT',
      headers,
      body: opts.body,
    });
  } catch (error) {
    if (error instanceof TypeError) {
      throw new Error('上传失败：网络异常、跨域限制，或预签名地址已失效');
    }
    throw error;
  }
}
